<div class=" order_sum_wrapper ">
    <fieldset class="scheduler-border">
        <legend class="scheduler-border">Search Criteria</legend>
        <form name="form" #referralSummary="ngForm" (ngSubmit)="getReferralSummary(1)" autocomplete="off">

            <div class="search-criteria">
                <div class="row">
                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback tag-reporting-fa">
                            <label for="dateFrom" class="control-label">Date From:</label>
                            <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom"
                                [maxDate]="DateTo" ngbDatepicker #dateFrom="ngbDatepicker" style="cursor: pointer;"
                                (click)="dateFrom.toggle()" readonly required>
                            <i (click)="dateFrom.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-sm-3 order_sum_col">
                        <div class="form-group has-feedback tag-reporting-fa">
                            <label for="DateTo" class="control-label">Date To:</label>
                            <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" ngbDatepicker
                                [maxDate]="maxDate" [minDate]="DateFrom" #dateTo="ngbDatepicker"
                                style="cursor: pointer;" (click)="dateTo.toggle()" readonly required>
                            <i (click)="dateTo.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div class="col-sm-2 order_sum_col">
                        <div class="form-group has-feedback">
                            <label for="StatusValue" class="control-label">Status Value</label>
                            <input type="text" id="StatusValue" name="StatusValue" placeholder="Enter Status Value"
                                [(ngModel)]="referralSummarySearchCriteria.statusValue" #StatusValue="ngModel"
                                class="form-control" minlength="1" maxlength="5" appOnlynumber
                                [ngClass]="{ 'is-invalid': StatusValue.invalid && (StatusValue.dirty || StatusValue.touched)}"
                                required />

                            <div *ngIf="StatusValue.invalid && (StatusValue.dirty || StatusValue.touched)"
                                class="invalid-feedback">
                                <div *ngIf="StatusValue.errors.required">Status value is required</div>
                                <div *ngIf="StatusValue.errors.minlength || StatusValue.errors.maxlength">Min 1 to 5 numbers
                                    are allowed</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group orders_sum_top tag_report">
                            <div class="pull-right">
                                <button type="submit" [disabled]="!referralSummary.valid" class="btn btn-primary">Search</button>
                                <button (click)="cancelSearch()" class="btn btn-default">Clear</button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </fieldset>

    <fieldset class="scheduler-border marign_10"s>
        <legend class="scheduler-border">Referral Summary Report</legend>
        <div class="panel_table">
            <div class="panel panel-default">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>
                                <th>ReferralName</th>
                                <th>ReferralEmail</th>
                                <th>ReferralPhoneNo</th>
                                <th>GUIDVal</th>
                                <th>StatusVal</th>
                                <th>CreateDate</th>
                                <th>Promo</th>
                                <th>DiscountType</th>
                                <th>DateFrom</th>
                                <th>DateTo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let mod of referralSummary">
                               
                                <td> {{mod.ReferralName}}</td>
                                <td> {{mod.ReferralEmail}}</td>
                                <td style="text-align:right"> {{mod.ReferralPhoneNo}}</td>
                                <td style="text-align:right"> {{mod.GUIDVal}}</td>
                                <td style="text-align:right"> {{mod.StatusVal}}</td>
                                <td style="text-align:right"> {{mod.CreateDate | date:'MM/dd/yyyy' }}</td>
                                <td style="text-align:right"> {{mod.Promo}}</td>
                                <td style="text-align:right"> {{mod.DiscountType}}</td>
                                <td style="text-align:right"> {{mod.DateFrom | date:'MM/dd/yyyy'}}</td>
                                <td style="text-align:right"> {{mod.DateTo | date:'MM/dd/yyyy'}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </fieldset>

</div>